import styled from 'styled-components';
import { Icon, getTheme, pxToRem } from '~/modules';
import Typography from '../Typography';

const backgroundZ1 = getTheme('background.z1');
const backgroundZ2 = getTheme('background.z2');
const xsSpacing = getTheme('spacing.xs');
const smSpacing = getTheme('spacing.sm');
const mdSpacing = getTheme('spacing.md');
const borderRadius = getTheme('themeRadius.card');
const textMain = getTheme('text.main');
const textLink = getTheme('text.link');

export const Wrapper = styled.div`
  background-color: ${backgroundZ2};
  padding: ${mdSpacing}px;
  border-radius: ${borderRadius}px;
  display: flex;
  flex-direction: column;
  gap: ${mdSpacing}px;
`;

export const ValueSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${xsSpacing}px;
`;

export const Title = styled(Typography)`
  color: ${textMain};
  opacity: 0.8;
  line-height: 1.5;
  opacity: 0.8;
`;

export const Value = styled(Typography).attrs({
  variant: 'max',
})``;

export const ValueWarningBox = styled.div`
  background-color: ${backgroundZ1};
  padding: ${mdSpacing}px;
  gap: ${mdSpacing}px;
  border-radius: ${borderRadius}px;
  display: flex;
  align-items: center;
`;

export const IconComponent = styled(Icon).attrs({
  fontSize: pxToRem(24),
})`
  color: ${textLink};
`;

export const ValueWarningBoxText = styled(Typography)`
  color: ${textLink};
  font-weight: 600;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${smSpacing}px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${smSpacing}px;
`;

export const DetailKey = styled(Typography)`
  color: ${textMain};
  opacity: 0.7;
`;

export const DetailValue = styled(Typography)`
  font-weight: 700;
  color: ${textMain};
  opacity: 0.7;
`;
